import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";
import Registration from "../views/Registration.vue"
import Results from "../views/Results.vue"
import Participant from "../views/Participant.vue"
import Audience from "../views/Audience.vue"
import About from "../views/About.vue"

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/registration",
    name: "Registration",
    component: Registration
  },
  {
    path: "/results",
    name: "Results",
    component: Results
  },
  {
    path: "/participant",
    name: "Participant",
    component: Participant
  },
  {
    path: "/audience",
    name: "Audience",
    component: Audience
  },
  {
    path: "/about",
    name: "About",
    component: About
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: function(to) {
    if (to.hash) {
      return window.scrollTo({
        top: 400,
        behavior: 'smooth'
      })
    } else {
      return { x: 0, y: 0 }
    }
  }
});

export default router;
